import type { OnboardingWizardStepId } from './onboardingWizardConfig';

/** Proto: 3 fases visibles (rubro → nombre → listo). Otros sigue siendo “paso 1”. */
export function protoProgress(stepId: OnboardingWizardStepId): {
  current: number;
  total: number;
} {
  const total = 3;
  if (stepId === 'identity') {
    return { current: 2, total };
  }
  // business-type | other-rubro
  return { current: 1, total };
}
